import { configureStore } from '@reduxjs/toolkit'

import turbineReducer from '../features/WTG/TurbineSlice'



/**
 * Creates a Redux store, and also automatically configure 
 * the Redux DevTools extension to inspect the store while developing.
 */
export const store = configureStore({
  reducer: {
    turbine: turbineReducer
  }
})

// // Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>
// // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch